import office from '@/taskpane/officejs/office-wrapper'
import state from '@/taskpane/state/sidebar-state'
import officeApiWrapper from '@/taskpane/common/office-api-wrapper'
import EmailInfo from '../models/mail-info'
import PersonInfo from '../models/person-info'
import CallbackArgs, { defaultCallbackArgs } from './callback-args'
import broadcastMessageToPortals from './broadcast-message-to-portals'

interface MailItemApiDataArgs extends CallbackArgs {
  bcc: PersonInfo[]
  threadId: string
  threadIndex: string
  headerMessageId: string
  datetime: string
  updateTracking: boolean
}

export async function sendItemApiDataMail(): Promise<void> {
  const apiInfo = await getMailItemApiData()

  if (apiInfo) {
    state.currentItem.apiInfo.updateMailInfo(apiInfo)

    const args = defaultCallbackArgs() as MailItemApiDataArgs
    args.bcc = apiInfo.bcc

    if (apiInfo.datetime) {
      args.datetime = apiInfo.datetime.toUTCString()
    }

    if (apiInfo.threadId) {
      args.threadId = apiInfo.threadId
      args.threadIndex = apiInfo.threadIndex
      args.updateTracking = state.currentItem.trackingInfoSentWithoutThreadId
    }

    if (apiInfo.headerMessageId) {
      args.headerMessageId = apiInfo.headerMessageId
    }

    broadcastMessageToPortals('MailItemApiData', args)
  }
}

async function getMailItemApiData(): Promise<EmailInfo> {
  try {
    const id = (await office.id()) || (await office.save())

    if (officeApiWrapper.isAvailable()) {
      return await officeApiWrapper.getMailInfo(id)
    } else {
      return await office.ews.getMailInfo(id)
    }
  } catch (error) {
    // don't let error here prevent sidebar from loading, just return what we can
    console.error('Error getting mail item API data:', { error })
    throw error
  }
}
